import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default function PermissionsList({
  permissions,
  loading,
  onEdit,
  onDelete,
  userId,
}) {
  if (loading) return <div className="text-center">Chargement...</div>;

  if (!permissions.length)
    return (
      <div className="text-center text-gray-500">
        Aucune permission trouvée.
      </div>
    );

  return (
    <div className="overflow-x-auto border rounded-lg bg-base-100 shadow-sm">
      <table className="table table-zebra w-full">
        <thead>
          <tr>
            <th>Code</th>
            <th>Nom</th>
            <th>Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {permissions.map((p) => (
            <tr key={p.id}>
              <td className="font-semibold">{p.code}</td>
              <td>{p.name}</td>
              <td className="max-w-xs truncate">{p.description}</td>

              <td className="flex gap-3">
                <button
                  onClick={() => onEdit(p)}
                  className="p-2 rounded-full hover:bg-gray-100 transition"
                >
                  <PencilIcon className="w-5 h-5 text-gray-700" />
                </button>

                <button
                  onClick={() => onDelete(p)}
                  className="p-2 rounded-full hover:bg-gray-100 transition"
                >
                  <TrashIcon className="w-5 h-5 text-red-600" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
